(() => {
  const initializeVideo = (video) => {
    if (video.dataset.madeDifferentControls === 'true') return;
    video.dataset.madeDifferentControls = 'true';
    let hideTimer;

    const clearHideTimer = () => window.clearTimeout(hideTimer);
    const showControls = () => {
      clearHideTimer();
      video.controls = true;
      if (!video.paused && !video.ended) {
        hideTimer = window.setTimeout(() => {
          video.controls = false;
        }, 1000);
      }
    };

    video.addEventListener('play', showControls);
    video.addEventListener('playing', showControls);
    video.addEventListener('pause', () => {
      clearHideTimer();
      video.controls = true;
    });
    video.addEventListener('ended', () => {
      clearHideTimer();
      video.controls = true;
    });
    video.addEventListener('pointermove', showControls);
    video.addEventListener('touchstart', showControls, { passive: true });
    video.addEventListener('click', () => {
      if (video.controls) return;
      if (video.paused) video.play();
      else video.pause();
    });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('.made-different-player video').forEach(initializeVideo);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initializeAll());
  else initializeAll();
  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
